import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DecoratorProfile } from '../domain/mockups/mockupsDto';

export type OrgState = {
  id: string;
  name: string;
  size?: number;
  purpose?: string;
  industry?: string;
  stripeCustomer?: string;
  stripeSubscription?: string;
  stripeApiSubscription?: string;
  createdAt?: string;
  updatedAt?: string;
  preview?: string;
  techpackDisclaimer?: string;
  productNamingConvention?: string;
  sharedAt?: string | null;
  approvedBrands?: string;
  decoratorProfile?: DecoratorProfile;
};

const initialState: OrgState = {
  id: '',
  name: '',
};

export const orgSlice = createSlice({
  name: 'org',
  initialState,
  reducers: {
    setOrg: (state: OrgState, action: PayloadAction<OrgState>) => {
      if (action.payload.id) state.id = action.payload.id;
      if (action.payload.name) state.name = action.payload.name;
      if (action.payload.size) state.size = action.payload.size;
      if (action.payload.industry) state.industry = action.payload.industry;
      if (action.payload.stripeCustomer) state.stripeCustomer = action.payload.stripeCustomer;
      if (action.payload.stripeSubscription)
        state.stripeSubscription = action.payload.stripeSubscription;
      if (action.payload.stripeApiSubscription)
        state.stripeApiSubscription = action.payload.stripeApiSubscription;
      if (action.payload.createdAt) state.createdAt = action.payload.createdAt;
      if (action.payload.updatedAt) state.updatedAt = action.payload.updatedAt;
      if (action.payload.preview) state.preview = action.payload.preview;
      if (action.payload.techpackDisclaimer !== undefined)
        state.techpackDisclaimer = action.payload.techpackDisclaimer;
      if (action.payload.productNamingConvention !== undefined)
        state.productNamingConvention = action.payload.productNamingConvention;
      if (action.payload.sharedAt !== undefined) state.sharedAt = action.payload.sharedAt;
      if (action.payload.approvedBrands !== undefined)
        state.approvedBrands = action.payload.approvedBrands;
      if (action.payload.decoratorProfile !== undefined)
        state.decoratorProfile = action.payload.decoratorProfile;
    },
    clearOrgPreview: (state: OrgState) => {
      state.preview = undefined;
    },
  },
});

export const { setOrg, clearOrgPreview } = orgSlice.actions;

export const orgReducer = orgSlice.reducer;
